<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                placeholder="Введите ФИО"
                v-model="currFilters.fio"
                label="Контекстный поиск (Фамилия, Имя, Отчество)"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Статус</label>
              <select
                @keyup.enter="apply"
                class="form-control"
                v-model="currFilters.status"
              >
                <option v-bind:value="-1">Все</option>
                <option
                  v-for="el in statusList"
                  v-bind:key="el.id"
                  :value="el.id"
                >
                  {{ el.text }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <component-input
                @keyupEnter="apply"
                v-model="currFilters.work"
                label="Место работы"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex">
        <button-component class="col-6" @click="apply">
          Применить
        </button-component>
        <button-component class="col-6" kind="secondary" @click="reset">
          Сбросить
        </button-component>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";

export default {
  name: "AppplicantFilters",
  components: { ComponentInput, ButtonComponent },
  props: {
    filters: Object,
  },
  data() {
    return {
      statusList: [
        {
          text: "Активный",
          id: 1,
        },
        {
          text: "Трудоустроен+",
          id: 2,
        },
        {
          text: "Трудоустроен-",
          id: 3,
        },
        {
          text: "Остановлен",
          id: 4,
        },
      ],
      currFilters: this.filters,
    };
  },
  methods: {
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit("apply", filters);
    },
    reset() {
      this.currFilters = {
        fio: "",
        status: -1,
        work: "",
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit("reset", filters);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
.form-group {
  label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }
}

.card-footer {
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
</style>
